// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tippy-popper .tippy-tooltip,.tippy-popper .tippy-tooltip .tippy-content{background-color:#fff}.tippy-popper .tippy-tooltip{box-shadow:0 3px 13px rgba(100,121,138,.039),0 10.5px 36px rgba(100,121,138,.19);padding:12px;width:300px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
